// Simple singleton EventBus for decoupled event communication
// Usage: import EventBus from '@api/local/EventBus'
// EventBus.on('event', handler)
// EventBus.emit('event', payload)
// EventBus.off('event', handler)

class EventBus {

  private static instance: EventBus
  private listeners: { [event: string]: Set<(...args: any[]) => void> } = {}

  private constructor() {}

  static shared(): EventBus {
    if (!EventBus.instance) {
      EventBus.instance = new EventBus()
    }
    return EventBus.instance
  }

  on(event: string, handler: (...args: any[]) => void) {
    if (!this.listeners[event]) {
      this.listeners[event] = new Set()
    }
    this.listeners[event].add(handler)
  }

  off(event: string, handler: (...args: any[]) => void) {
    this.listeners[event]?.delete(handler)
  }

  emit(event: string, ...args: any[]) {
    this.listeners[event]?.forEach(handler => {
      try {
        handler(...args)
      } catch (e) {
        // Optionally log error
        // console.error('EventBus handler error:', e)
      }
    })
  }

}

export default EventBus.shared()
